import React from 'react';
import styled from 'styled-components';
import { breakpoints } from '@sorted/sorted-ui';
import Sidebar from '../../components/Sidebar';
import ContentRoutes from '../../routing/ContentRoutes';
import MobileHeader from '../../components/MobileHeader';

const Layout = styled.div`
	padding-top: 60px;
	@media (min-width: ${breakpoints.smallDesktop}) {
		display: flex;
		height: 100vh;
		overflow: hidden;
		flex-direction: row;
		padding-top: unset;
	}
`;

const Main = styled.main`
	flex: 1 1 100%;

	@media (min-width: ${breakpoints.smallDesktop}) {
		overflow: auto;
	}
`;

const Home = () => (
	<Layout>
		<MobileHeader />
		<Sidebar />
		<Main>
			<ContentRoutes />
		</Main>
	</Layout>
);

export default Home;
